<template>
    <div id="page-content-wrapper" class="admin-page-content page-not-found">
      <div class="col-md-12 error-detail-main forms-container">
        <div class="error-template">
          <h1>404 - Page Not Found</h1>
          <div class="error-content">
            The page you are looking for does not exist.
          </div>
          <button class="extraFeature btn btn-primary waves-effect ml-2" @click="goToHomePage">
            Go To Home Page
          </button>
        </div>
      </div>
      <app-footer></app-footer>
    </div>
</template>

<script>
var self;
import Footer from "@/components/partials/Footer";
import {HTTP} from '../http-common';
import {commonMixins} from '../mixins/commonMixins';

export default {
  name: "PageNotFound",
  mixins: [commonMixins],
  components: {
    "app-footer": Footer,
  },
  data() {
    return {};
  },
  beforeMount() {
    self = this;
  },
  methods: {
    goToHomePage() {
      if(localStorage.getItem('user_obj')) {
        self.getFirstMenu();
      } else {
        self.$router.push({ name: "Login" });
      }
    },
    getFirstMenu: function () {
        HTTP.get("get_first_menu", [])
          .then(function (response) {
              if (response.data.code == 200) {
                  window.location.href = "/" + response.data.content.slug;
              }
          })
          .catch(function (err) {
              self.catchHandler(err, function () {});
          });
    }
  }
};
</script>

